iScreenWizard.controller('ProfielController', function ($scope, $state, $mdDialog, Ajax, Dictionary, Profiel, userService) {

    $scope.profiel = {};

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        Profiel.get().then(function (profiel) {
            $scope.profiel = profiel;
            $scope.profiel.oudwachtwoord = '';
            $scope.profiel.nieuwwachtwoord1 = '';
            $scope.profiel.nieuwwachtwoord2 = '';
        });
    };

    $scope.saveProfile = function() {
        var params = {};
        params.voornaam = $scope.profiel.voornaam;
        params.achternaam = $scope.profiel.achternaam;

        if ($scope.profiel.oudwachtwoord.length > 0 || $scope.profiel.oudwachtwoord.length > 0 || $scope.profiel.oudwachtwoord.length > 0) {
            params.oudwachtwoord = $scope.profiel.oudwachtwoord;
            params.nieuwwachtwoord1 = $scope.profiel.nieuwwachtwoord1;
            params.nieuwwachtwoord2 = $scope.profiel.nieuwwachtwoord2;
        }

        $mdDialog.show(
            $mdDialog.alert()
                .clickOutsideToClose(false)
                .textContent(Dictionary.translate('app.saving', true))
                .ariaLabel(Dictionary.translate('app.saving', true))
        );

        Ajax.put('profile', params).then(function (response) {
            if (response.data.succes) {
                //profile successfully updated
                userService.model.voornaam = $scope.profiel.voornaam;
                userService.model.achternaam = $scope.profiel.achternaam;
                userService.SaveState();

                $scope.refresh();
                $mdDialog.hide();
            } else {
                //something went wrong
                errorMessage = Dictionary.translate('app.something_went_wrong', true);
                if (!response.data._errors.empty) {
                    errorMessage = "";
                    angular.forEach(response.data._errors, function(value, key) {
                        errorMessage += value + '<br/>';
                    });
                }
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title(Dictionary.translate('app.could_not_save', true))
                        .htmlContent(errorMessage)
                        .ariaLabel(Dictionary.translate('app.could_not_save', true))
                        .ok(Dictionary.translate('app.okay', true))
                );
            }
            //wachtwoord velden leeg maken
            $scope.profiel.oudwachtwoord = '';
            $scope.profiel.nieuwwachtwoord1 = '';
            $scope.profiel.nieuwwachtwoord2 = '';
        }, function () {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(Dictionary.translate('app.warning', true))
                    .textContent(Dictionary.translate('app.something_went_wrong', true))
                    .ariaLabel(Dictionary.translate('app.warning', true))
                    .ok(Dictionary.translate('app.okay', true))
            );

        });
    };


});